module.exports = __webpack_public_path__ + "static/media/Scragg 18T Driven.8f7b7cb4.jpg";